import { Overlay, ScrollStrategy } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { CDK_IMPORTS } from '@utils/standalone-imports';
import { IconSanitizerService } from 'ngx-lib';

@Component({
    selector: 'app-kebab-menu',
    templateUrl: './kebab-menu.component.html',
    styleUrls: ['./kebab-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, ...CDK_IMPORTS]
})
export class KebabMenuComponent {
    @ViewChild('kebabButton') public kebabButton!: ElementRef;

    kebabIcon: SafeHtml;
    protected panelOpen = false;

    protected scrollStrategy: ScrollStrategy;

    constructor(
        private overlay: Overlay,
        private readonly iconSanitizer: IconSanitizerService
    ) {
        this.kebabIcon = this.iconSanitizer.getIcon('kebab');
        this.scrollStrategy = this.overlay.scrollStrategies.close();
    }

    openPanel(event: Event) {
        this.panelOpen = !this.panelOpen;
        event.preventDefault();
        event.stopPropagation();
    }

    @HostListener('document:click', ['$event'])
    onDocumentClicked(event: MouseEvent): void {
        if (!this.kebabButton.nativeElement.contains(event.target) && this.panelOpen) {
            this.panelOpen = false;
        }
    }
}
